<template>
  <select
    :type="type"
    :disabled="disabled"
    :value="value"
    class="widget_select"
    @change="onChange"
    @blur="onBlur"
    @focus="onFocus"
    @click="onClick"
  >
    <option value="none">{{ placeholder }}</option>
    <option v-for="(item, index) in opt" :key="index" :value="item.value">
      {{ item.label }}
    </option>
  </select>
</template>

<script>
export default {
  name: "widget_select",
  props: {
    type: {
      type: String,
      default: "text",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    opt: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {
    onChange(e) {
      let vm = this;
      vm.$emit("change", e.target.value);
      vm.$emit("input", e.target.value);
    },
    onBlur(e) {
      let vm = this;
      vm.$emit("blur", e);
    },
    onFocus(e) {
      let vm = this;
      vm.$emit("focus", e);
    },
    onClick(e) {
      let vm = this;
      vm.$emit("click", e);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/scss/constant_valiable.scss";
.widget_select {
  padding: 14px 10px;
  border-radius: 5px;
  font-weight: 500;
  width: 100%;
  position: relative;
  background: #fff;
  border-width: 1px;
  border-style: solid;
  outline: none;
  border-color: #c3cad9;
  color: #5a7184;
}
</style>
